import {isValid} from 'date-fns';
import * as yup from 'yup';

export const SignUpSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email is required'),
  password: yup.string().required('Password is required'),
  confirmPassword: yup
    .string()
    .required('Passwords must match')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  phone: yup
    .string()
    .required('Phone Number is required')
    .test('Phone Test', 'Invalid Phone Number', (value) =>
      value ? value[0] === '+' : false,
    ),
  acceptsMarketing: yup.boolean(),
  acceptsTerms: yup.boolean().isTrue('Must be accepted'),
});

export const ForgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email is required'),
});

export const ResetPasswordSchema = yup.object().shape({
  password: yup.string().required('Password is required'),
  confirmPassword: yup
    .string()
    .required('Passwords must match')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});

export const SignInSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email is required'),
  password: yup.string().required('Password is required'),
});

export const EditAccountSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email is required'),
  acceptsMarketing: yup.boolean(),
  firstName: yup.string().required('First Name is Required'),
  lastName: yup.string().required('Last Name is Required'),
  phone: yup
    .string()
    .test('Phone Test', 'Invalid Phone Number', (value) =>
      value ? value[0] === '+' : true,
    ),
  gender: yup.object().shape({value: yup.string(), label: yup.string()}),
  birthDate: yup
    .date()
    .nullable()
    .test(
      'Birth Date Test',
      'Invalid Date',
      (value) => !value || isValid(value),
    ),
});

export const ChangePasswordSchema = yup.object().shape({
  newPassword: yup.string().required('New Password is required'),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match'),
});

export const EditAddressSchema = yup.object().shape({
  address1: yup.string().required('Field is Required!'),
  address2: yup.string().nullable(),
  country: yup.string().required('Field is Required!'),
  company: yup.string().nullable(),
  city: yup.string().required('Field is Required!'),
  province: yup.string().nullable(),
  firstName: yup.string().required('Field is Required!'),
  lastName: yup.string().required('Field is Required!'),
  phone: yup.string().nullable(),
  zip: yup.string().required('Field is Required!'),
  defaultAddress: yup.boolean(),
});
